import {
  EventInterface,
  MyEventInterface,
} from 'common/components/entities/Calendar/calendar-interface'
import { commonHttpClient } from 'src/editor/api/http-clients/common-http-client'

export const getMyEvents = () => {
  return commonHttpClient.get<MyEventInterface[]>(
    `/api/dashboard/booking-calendar/event/my-events`,
  )
}

export const getEvent = (eventId: EventInterface['id']) => {
  return commonHttpClient.get<EventInterface>(
    `/api/dashboard/booking-calendar/event/${eventId}`,
  )
}
